import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Icon, Text } from 'components/ui';
import { colors, site, space } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import FreeShippingBannerEN from 'components/Banner/FreeShippingBanner/locales/FreeShippingBanner_en_US';
import FreeShippingBannerFR from 'components/Banner/FreeShippingBanner/locales/FreeShippingBanner_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(FreeShippingBannerEN, FreeShippingBannerFR);

const FreeShippingBanner = () => (
    <Flex
        alignItems='center'
        justifyContent='center'
        backgroundColor={colors.lightBlue}
        paddingY={1}
        gap={2}
        maxWidth={[null, null, null, site.FREE_SHIPPING_BANNER_MAX_WIDTH]}
        marginBottom={[null, null, null, 4]}
    >
        <Icon
            name='truck'
            size={space[4]}
        />
        <Text
            fontSize={['sm', null, null, 'base']}
            children={getText('freeShippingMessage')}
        />
    </Flex>
);

export default wrapFunctionalComponent(FreeShippingBanner, 'FreeShippingBanner');
